/**
 * Features:
 * - §14.4.5 loose-cigars row art: three resting cigars with a band accent on the
 *   centre stick.
 */
import {
  ILLUSTRATION_ACCENT,
  PortalIllustration,
  type PortalIllustrationProps,
} from './portal-illustration';

type Props = Omit<PortalIllustrationProps, 'viewBox' | 'children'>;

export function LooseCigarsIllustration(props: Props) {
  return (
    <PortalIllustration viewBox="0 0 120 60" {...props}>
      {/* back cigar — flat cut end (left), rounded head (right) */}
      <path d="M18 14h68a4 4 0 0 1 0 8H18Z" />
      {/* middle cigar with band */}
      <path d="M12 30h76a4 4 0 0 1 0 8H12Z" />
      <path d="M54 29.5v9M62 29.5v9" stroke={ILLUSTRATION_ACCENT} />
      {/* front cigar */}
      <path d="M22 46h64a4 4 0 0 1 0 8H22Z" />
      {/* resting line */}
      <path d="M8 56h104" />
    </PortalIllustration>
  );
}
